module.exports = __webpack_public_path__ + "img/RutvijJadhav-Circular.f02c093.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/RutvijJadhav-Circular.jpeg
// module id = 1645
// module chunks = 1